import { get, put, post, del } from 'api/request';
import urls from 'configs/urls';

export const getPriceList = queryString =>
  get(null, false, `${urls.categoriesApi.priceLists}?${queryString}`, null);

export const createPriceList = payload =>
  post(null, false, `${urls.categoriesApi.priceLists}`, payload);

export const editPriceList = payload =>
  put(null, false, `${urls.categoriesApi.priceLists}/${payload?.id}`, payload?.data);

export const getProviders = queryString =>
  get(null, false, `${urls.categoriesApi.providers}?${queryString}`, null);

export const branches = (queryString, countryId) => {
  const headers = {
    countryid: countryId,
    'Accept-Language': 'en-EG',
  };
  return get(headers, false, `${urls.categoriesApi.branches}?${queryString}`, null);
};
// Search Provider
export const searchDoctors = (queryString, countryid = 1) => {
  const headers = {
    countryid,
    'Accept-Language': 'en-EG',
  };

  return get(headers, false, `${urls.search.searchDoctor}?${queryString}`, null);
};

// Get Doctor Profile
export const getDoctorProfile = (queryString, countryId = 1) => {
  const headers = {
    countryid: countryId,
    'Accept-Language': 'en-EG',
  };
  return get(headers, false, `${urls.search.doctorProfile}?${queryString}`, null);
};

// Search pharmacies
export const searchPharmacies = ({ pharmacyName }, countryId) => {
  const headers = {
    countryid: countryId,
    'Accept-Language': 'en-EG',
  };
  // eslint-disable-next-line max-len
  const queryString = `isActive=true&pharmacyName=${pharmacyName}&pageNumber=1&pageSize=12&includes=Translators`;
  return get(headers, false, `${urls.categoriesApi.pharmacies}?${queryString}`, null);
};

// Add Provider
export const addProvidersBulk = payload =>
  put(null, false, `${urls.categoriesApi.providers}/bulk`, payload);

// Remove Provider
export const removeProvider = payload =>
  del(
    { 'Content-Type': 'application/json' },
    false,
    `${urls.categoriesApi.providers}/${payload?.id}`,
    { data: payload?.data }, // axios prevents body on delete requests to enable it add the payload to data option
  );

// Edit Provider
export const editProvider = payload =>
  put(null, false, `${urls.categoriesApi.providers}/${payload?.id}`, payload?.data);

export const getAreas = () => get(null, false, urls.categoriesApi.areas, null);

export const getDropdowns = () =>
  get({ Language: 'en' }, false, urls.categoriesApi.dropdowns, null);

export const getServices = queryString =>
  get(null, false, `${urls.categoriesApi.services}?${queryString}`, null);

export const addService = payload => put(null, false, urls.categoriesApi.services, payload);

export const removeService = payload =>
  del(
    { 'Content-Type': 'application/json' },
    false,
    `${urls.categoriesApi.services}/${payload?.id}`,
    { data: payload?.data }, // axios prevents body on delete requests to enable it add the payload to data option
  );

export const getMedicalServices = (queryString, countryId) => {
  const headers = {
    countryid: countryId,
    'Accept-Language': 'en-EG',
  };
  return get(headers, false, `${urls.categoriesApi.medicalServices}?${queryString}`, null);
};

// Get HealthPlan Info by PlanID
export const getHealthPlanById = healthPlanId =>
  get(null, false, `${urls.healthPlansApi.HealthPlans}/${healthPlanId}`, null);

// Get PriceList Info by priceListId
export const getPriceListById = priceListId =>
  get(null, false, `${urls.categoriesApi.priceLists}/${priceListId}`, null);

export const searchEntities = (queryString, countryid = 1) => {
  const headers = {
    countryid,
    'Accept-Language': 'en-EG',
  };

  return get(headers, false, `${urls.categoriesApi.searchEntities}?${queryString}`, null);
};

export const entityProviders = queryString => {
  const headers = {
    'Accept-Language': 'en-EG',
  };

  return get(headers, false, `${urls.categoriesApi.entityProviders}?${queryString}`, null);
};

export const addEntityProvider = ({ data }) =>
  post(null, false, urls.categoriesApi.addEntityProvider, data);

export const editEntityProvider = ({ providerKey, data }) =>
  put(null, false, `${urls.categoriesApi.editEntityProvider}/${providerKey}`, data);

export const deleteEntityProvider = ({ providerKey, data }) =>
  del(null, false, `${urls.categoriesApi.deleteEntityProvider}/${providerKey}`, { data });
